import isPropValid from '@emotion/is-prop-valid';

export function shouldForwardProp(propName: string, target: unknown) {
	if (typeof target === 'string') {
		// for HTML elements, forward the prop if it is a valid HTML attribute
		return isPropValid(propName);
	}

	// for other elements, forward all props
	return true;
}
